import React from 'react';
import fetch from '../fetch';

import utils from '../../utils';

import moment from 'moment';

import {Popover} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const headers = utils.columns([
    { type: 'selection' },
    { key: '$index', label: '序号' , width: 70},
    {
        key: 'folderName', width: 200,
        label: '所属目录',
        render: (value,row,data) =>
        <span> 
            <Popover placement="topLeft" style={{ width: 300 }}  content={
                <div style={{ width: 200 }}>
                    {
                        row.folderName
                    }
                </div>} 
                title="目录名称"
                >
                {value}
            </Popover>
        </span> 
    },
    {
        key: 'fileName', width: 250,
        label: '文件名称',
        render: (value,row,data) =>
        <span> 
            <Popover placement="topLeft" style={{ width: 300 }}  content={
                <div style={{ width: 200 }}>
                    {
                        row.fileName
                    }
                </div>} 
                title="文件名称"
                >
                {value}
            </Popover>
        </span> 
    },
    {
        key: 'operatorName', width: 80,
        label: '上传人'
    },
    {
        key: 'termName', width: 120,
        label: '所属学期'
    },
    { key: 'createTime', label: '创建日期', width: 100, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
    { type:'action', label: '操作', values: ['read','video','image', 'down', 'file']},
])

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
 const querySearch = (keywords = {pageNum: 1, pageSize: 100, }) => {

    const defaultsParams = {
    };
    return fetch.post('zgcp/file/query', Object.assign(defaultsParams, keywords))
    .then(response => {
        return response.payload.data;
    })
    .then(data => {
        const list = (
            Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        }))
        DataGrid.data = list.result;
        return list;
    });
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const exist = (id) => {
    return fetch.post('zgcp/file/exist/'+ id)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

const resetFileData = (keywords = {}) => {
    return fetch.post('zgcp/file/resetFileData', keywords)
    .then((response) => {
       return response;
    })
}

export default {
    querySearch,
    headers,
    onSelect,
    setRefresh,
    getSelection,
    exist,
    resetFileData
}
